<template>
  <div class="toast">
    <span class="text-sm">Smart-Glasses have been disconnected</span>
    <button @click="closeToast">
      <CrossSimpleIcon type="link"></CrossSimpleIcon>
    </button>
  </div>
</template>

<script>
import CrossSimpleIcon from '@/Components/Icons/CrossSimpleIcon.vue';

export default {
  components: { CrossSimpleIcon },
  emits: ['toggleSmartGlassToast'],
  setup(props, { emit }) {
    const closeToast = () => {
      emit('toggleSmartGlassToast');
    };
    return { closeToast };
  },
};
</script>

<style scoped>
.toast {
  position: absolute;
  right: 0;
  z-index: 999;
  top: 2rem;
  min-width: 200px;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  color: white;
  display: flex;
  align-items: center;
  background-color: #656262;
}
</style>
